<!--
 * @Author: zhouhm 1148305943@qq.com
 * @Date: 2022-09-22 16:47:59
 * @LastEditors: zhouhm 1148305943@qq.com
 * @LastEditTime: 2025-09-22 15:47:27
 * @FilePath: \road_monitor_app\src\view\yeMast\yeMast.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="yeMast">
        <div class="engineer-box">
            <!-- <el-select v-model="videoUrl" placeholder="请选择" @change="changeVideo">
                <el-option v-for="(item, key) in videoList" :key="key" :label="item.deviceName" :value="item.url">
                </el-option>
            </el-select> -->

            <select class="selectBox" placeholder="请选择!" v-model="videoUrl" @change="changeVideo($event)">
                <option v-for="(item, key) in videoList" :key="key" :value="item.url">
                    {{item.deviceName}}
                </option>
            </select>

            <!-- <i class="el-icon-arrow-down"></i> -->
        </div>
        <div class="content">
            <div class="video">
                <template>
                    <template v-if="hasUrl && !checkVideo">
                        <div id="mse" style="width: 100%; height: 100%; object-fit: contain ;background-color: #000!important;"/>
                        <!-- <video ref="player" id="myPlayer" width="100%" controls muted preload="auto" webkit-playsinline="true" playsinline="true" style="width: 100%; height: 100%; object-fit: contain ;background-color: #000!important;">
                            <source :src="videoData.videoUrl" type="application/x-mpegURL" />
                        </video> -->
                    </template>
                    <template v-if="!hasUrl">
                        <div style="position: relative;height:100%">
                            <img style="width: 100%;position: absolute; top: 50%; left: 50%;transform: translate(-50%,-50%);" src="../../assets/zwsp.png" />
                        </div>
                    </template>
                </template>
            </div>
        </div>
        <a  class="bottomtext" target="_blank" rel="noopener noreferrer" href="https://beian.miit.gov.cn">备案号:苏ICP备11019701号</a>

    </div>
</template>
<script>
    import mix from "./yeMast_index";
    // import BaseVideo  from "@/components/BaseVideo";
    export default {
        mixins: [mix],
        components: {
            // BaseVideo
        }
    };
</script>
<style lang="less" scoped>
    @import "./yeMast.less";
</style>


// WEBPACK FOOTER //
// src/view/yeMast/yeMast.vue